module.exports = __webpack_public_path__ + "static/media/41-8.08640e5c.mp3";